import {
	PqAttemptStateInitializer
} from "@sabyr-dev/mist_core/model/datasource/stateinitializer";
import { AttemptState } from "@sabyr-dev/mist_core/model/datasource/state";
import { AcademyAttemptState } from "./state";
import {
	getAttemptId, getCookie, getMode, getProductId, getStarted, getTestId,
	getTestName
} from "./academy";

export class AcademyAttemptStateInitializer extends PqAttemptStateInitializer {
	getInitialState(cache?: AcademyAttemptState): AcademyAttemptState {
		return {
			...super.getInitialState(cache),
			userData: cache?.userData ?? {},
			cookie: getCookie(),
			testId: getTestId(),
			testName: getTestName(),
			productId: getProductId(),
			attemptId: getAttemptId(),
			mode: getMode(),
			started: getStarted()
		};
	}

	getInitialTimes(cache?: AttemptState): AttemptState["times"] {
		return cache?.times ?? {};
	}
}
